import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import FinReportsComp from './FinReportsComp'
 

function FinanceReports() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <FinReportsComp/>      
        </div>
    </div>
  )
}

export default FinanceReports